import $ from "jquery";

export function collapseActive() {

    $('.collapse').on('show.bs.collapse', function () {
        $(this).parent().addClass('active');
    });

    $('.collapse').on('hide.bs.collapse', function () {
        $(this).parent().removeClass('active');
    });
}

collapseActive()
